import React from "react";
import { useSelector } from "react-redux";

import GeneralInformation from "components/pages/transmissions/modal/patient/tabs/generalInformation/GeneralInformation";
import MedicalInformation from "components/pages/transmissions/modal/patient/tabs/medicalInformation/MedicalInformation";
import DeviceInformation from "components/pages/transmissions/modal/patient/tabs/deviceInformation/DeviceInformation";

import InsuranceInformation from "components/pages/transmissions/modal/patient/tabs/insuranceInformation/InsuranceInformation";
import DataPoints from "components/pages/transmissions/modal/patient/tabs/datapoints/Datapoints";
import Subscription from "components/pages/transmissions/modal/patient/tabs/subscription/Subscription";
import PatientReport from "components/pages/transmissions/modal/patient/tabs/generalInformation/tabs/report/PatientReport";

const usePatientProfileTabs = () => {
  const { hasAccessToProfileTabs } = useSelector((state) => state.transmission);

  const PATIENT_PROFILE_TABS = [
    {
      label: "General Information",
      value: "generalInformation",
      component: <GeneralInformation />,
    },
    {
      label: "Medical History",
      value: "medicalHistory",
      component: <MedicalInformation />,
    },
    {
      label: "Device Information",
      value: "deviceInformation",
      component: <DeviceInformation />,
    },
    {
      label: "Insurance Information",
      value: "insuranceInformation",
      component: <InsuranceInformation />,
    },
    {
      label: "Data Points",
      value: "datapoints",
      component: <DataPoints />,
    },
    {
      label: "Communication",
      value: "communication",
      component: <Subscription />,
    },
  ];

  const PATIENT_PROFILE_DEFAULT_TABS = [
    {
      label: "Reports",
      value: "reports",
      component: <PatientReport />,
    },
  ];

  const tabs = hasAccessToProfileTabs
    ? PATIENT_PROFILE_TABS
    : PATIENT_PROFILE_DEFAULT_TABS;

  return [tabs];
};

export default usePatientProfileTabs;
